import React, { useEffect, useState, useMemo, useCallback } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import * as moment from "moment";
import { Link } from "react-router-dom";
import BreadCrumb from "../../Components/Common/BreadCrumb";

import { isEmpty } from "lodash";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import {
  getFiles as onGetFiles,
  importFile as onImportFile,
  getSuppliers as onGetSuppliers,
  deleteBatch as onDeleteBatch,
} from "../../slices/thunks";

import Loader from "../../Components/Common/Loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { createSelector } from "reselect";
import { useFormik } from "formik";

import ShowImports from "./showImported";

import TableContainer from "./TableContainer";
import DeleteModal from "../../Components/Common/DeleteModal";

const ImportFile = () => {
  const [modal, setModal] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showImports, setShowImports] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  const [uploadfile, setUploadFile] = useState(null);
  const dispatch = useDispatch();

  const selectFilesData = createSelector(
    (state) => state.Files,
    (files) => files,
    (loading) => loading
  );

  const selectImportFiles = createSelector(
    (state) => state.Files.uploadfile,
    (files) => files
  );

  const selectSuppliersData = createSelector(
    (state) => state.Suppliers.suppliers,
    (suppliers) => suppliers
  );

  const { files, loading } = useSelector(selectFilesData);
  const suppliers = useSelector(selectSuppliersData);
  const upload = useSelector(selectImportFiles);

  const [fileList, setFileList] = useState([]);
  const [suppliersList, setSuppliersList] = useState([]);

  // File validation
  const fileValidation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      file: (uploadfile && uploadfile.fileName) || "",
      sup_id: "",
      salesChannel: "",
    },
    onSubmit: (values) => {
      //validate that file is selected and supplier is selected and sales channel is selected
      if (!uploadfile) {
        toast.error("Please select a file", {
          autoClose: 3000,
        });
        return;
      }
      if (!values.supplier) {
        toast.error("Please select a supplier", {
          autoClose: 3000,
        });
        return;
      }
      if (!values.salesChannel) {
        toast.error("Please select a sales channel", {
          autoClose: 3000,
        });
        return;
      }
      const formData = new FormData();
      formData.append("file", uploadfile);
      formData.append("sup_id", values.supplier);
      formData.append("salesChannel", values.salesChannel);
      toast.loading("Importing file...", {});

      dispatch(onImportFile(formData));
      fileValidation.resetForm();
      toggle();
    },
  });

  useEffect(() => {
    if (upload) {
      dispatch(onGetFiles());
    }
  }, [upload]);

  useEffect(() => {
    if (!isEmpty(files)) setFileList(files);
  }, [files]);

  useEffect(() => {
    if (!isEmpty(suppliers)) {
      setSuppliersList(
        suppliers.filter((supplier) => supplier.sup_status === 0)
      );
    }
  }, [suppliers]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredFiles = files;
      if (type !== "all") {
        filteredFiles = files.filter((file) => file.status === type);
      }
      setFileList(filteredFiles);
    }
  };

  // validation
  /*

  useEffect(() => {
    console.log("files", files);
    if (!files) {
      dispatch(onGetFiles());
    }
  }, [dispatch, files]);
  */

  useEffect(() => {
    dispatch(onGetFiles());
    if (!suppliers || suppliers.length === 0) {
      const data = {
        page: 0,
        total_rows: 1000,
        sort_by: "sup_name",
        asc: true,
      };
      dispatch(onGetSuppliers(data));
    }
  }, []);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      //setFileList(null);
    } else {
      setModal(true);
      //setDate(defaultdate());
    }
  }, [modal]);

  const handleOrderClicks = () => {
    setFileList(null);
    // setIsEdit(false);
    toggle();
  };

  // Node API
  // useEffect(() => {
  //   if (isOrderCreated) {
  //     setOrder(null);
  //     dispatch(onGetOrders());
  //   }
  // }, [
  //   dispatch,
  //   isOrderCreated,
  // ]);

  // Checked All
  const checkedAll = useCallback(() => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".orderCheckBox");
    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
    deleteCheckbox();
  }, []);

  // Delete Multiple
  const [selectedCheckBoxDelete, setSelectedCheckBoxDelete] = useState([]);
  const [isMultiDeleteButton, setIsMultiDeleteButton] = useState(false);

  const deleteCheckbox = () => {
    const ele = document.querySelectorAll(".orderCheckBox:checked");
    ele.length > 0
      ? setIsMultiDeleteButton(true)
      : setIsMultiDeleteButton(false);
    setSelectedCheckBoxDelete(ele);
  };

  const handleDelete = () => {
    console.log("selectedBatch.bai_id", selectedBatch.bai_id);
    dispatch(onDeleteBatch({ bai_id: selectedBatch.bai_id }));
    setShowDelete(false);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        header: "Date",
        accessorKey: "bai_date",
        enableColumnFilter: false,
        cell: (cell) => {
          const estDate = moment.utc(cell.getValue()).subtract(5, "hours");
          return (
            <>
              {estDate.format("MM/DD/YYYY")}
              <small className="text-muted">
                <br />
                {estDate.format("hh:mm A")} EST
              </small>
            </>
          );
        },
      },
      {
        header: "Supplier",
        accessorKey: "sup_name",
        enableColumnFilter: false,
        cell: (cell) => {
          return (
            <span className="text-dark">
              {cell.getValue() ? cell.getValue() : "N/A"}
            </span>
          );
        },
      },
      {
        header: "User",
        accessorKey: "user_name",
        enableColumnFilter: false,
      },
      {
        header: "Sales Channel",
        accessorKey: "bai_salesChannel",
        enableColumnFilter: false,
        cell: (cell) => {
          switch (cell.getValue()) {
            case "FBA":
              return (
                <span
                  style={{ width: 100 }}
                  className="badge text-dark bg-success"
                >
                  FBA
                </span>
              );
            case "FBM":
              return (
                <span
                  style={{ width: 100 }}
                  className="badge text-dark bg-warning"
                >
                  FBM
                </span>
              );
            case "eBay":
              return (
                <span
                  style={{ width: 100 }}
                  className="badge text-dark bg-danger"
                >
                  eBay
                </span>
              );

            case "Walmart":
              return (
                <span
                  style={{ width: 100 }}
                  className="badge text-dark bg-primary "
                >
                  Walmart
                </span>
              );
            case "other":
              return (
                <span
                  style={{ width: 100 }}
                  className="badge text-dark bg-pink "
                >
                  Other
                </span>
              );
            case "Other":
              return (
                <span
                  style={{ width: 100 }}
                  className="badge text-dark bg-pink "
                >
                  Other
                </span>
              );
            case "LIQUIDATIONS":
              return (
                <span
                  style={{ width: 100 }}
                  className="badge text-dark bg-secondary "
                >
                  LIQUIDATIONS
                </span>
              );
          }
        },
      },
      {
        header: "Total",
        accessorKey: "bai_total",
        enableColumnFilter: false,
      },
      {
        header: "Success",
        accessorKey: "bai_success",
        enableColumnFilter: false,
      },
      {
        header: "Failed",
        accessorKey: "bai_failed",
        enableColumnFilter: false,
      },
      {
        header: "Filtered Brand",
        accessorKey: "bai_filteredBrand",
        enableColumnFilter: false,
      },
      {
        header: "Filtered Meltable",
        accessorKey: "bai_filteredMeltable",
        enableColumnFilter: false,
      },
      {
        header: "Filtered ASIN",
        accessorKey: "bai_filteredASIN",
        enableColumnFilter: false,
      },
      {
        header: "Status",
        accessorKey: "bai_status",
        enableColumnFilter: false,
        cell: (cell) => {
          switch (cell.getValue()) {
            case "Pending":
              return (
                <span className="badge text-uppercase bg-warning-subtle text-warning">
                  {" "}
                  {cell.getValue()}{" "}
                </span>
              );
            case "Cancelled":
              return (
                <span className="badge text-uppercase bg-danger-subtle text-danger">
                  {" "}
                  {cell.getValue()}{" "}
                </span>
              );
            case "Inprogress":
              return (
                <span className="badge text-uppercase bg-secondary-subtle text-secondary">
                  {" "}
                  {cell.getValue()}{" "}
                </span>
              );
            case "Pickups":
              return (
                <span className="badge text-uppercase bg-info-subtle text-info">
                  {" "}
                  {cell.getValue()}{" "}
                </span>
              );
            case "Returns":
              return (
                <span className="badge text-uppercase bg-primary-subtle text-primary">
                  {" "}
                  {cell.getValue()}{" "}
                </span>
              );
            case 0:
              return (
                <span className="badge text-uppercase bg-success-subtle text-success">
                  success
                </span>
              );
            default:
              return (
                <span className="badge text-uppercase bg-warning-subtle text-warning">
                  {" "}
                  {cell.getValue()}{" "}
                </span>
              );
          }
        },
      },

      {
        header: "Action",
        cell: (cellProps) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item">
                <Link
                  onClick={() => {
                    setSelectedBatch(cellProps.row.original);
                    setShowImports(true);
                  }}
                  className="text-primary d-inline-block"
                >
                  <i className="ri-eye-fill fs-16"></i>
                </Link>
              </li>
              <li className="list-inline-item">
                <Link
                  onClick={() => {
                    setSelectedBatch(cellProps.row.original);
                    setShowDelete(true);
                  }}
                  className="text-danger d-inline-block"
                >
                  <i className="ri-delete-bin-6-fill fs-16"></i>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    [checkedAll]
  );

  const defaultdate = () => {
    let d = new Date(),
      months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
    let h = d.getHours() % 12 || 12;
    let ampm = d.getHours() < 12 ? "AM" : "PM";
    return (
      d.getDate() +
      " " +
      months[d.getMonth()] +
      ", " +
      d.getFullYear() +
      ", " +
      h +
      ":" +
      d.getMinutes() +
      " " +
      ampm
    ).toString();
  };

  const [date, setDate] = useState(defaultdate());

  const dateformate = (e) => {
    const dateString = e.toString().split(" ");

    let time = dateString[4];
    let H = +time.substr(0, 2);
    let h = H % 12 || 12;
    h = h <= 9 ? (h = "0" + h) : h;
    let ampm = H < 12 ? "AM" : "PM";
    time = h + time.substr(2, 3) + " " + ampm;

    const date = dateString[2] + " " + dateString[1] + ", " + dateString[3];
    const orderDate = (date + ", " + time).toString();
    setDate(orderDate);
  };

  const handleValidDate = (date) => {
    const date1 = moment(new Date(date)).format("DD MMM Y");
    return date1;
  };

  const handleFileSelect = (event) => {
    setUploadFile(event.target.files[0]);
  };
  document.title = "Import Files | Buyers Club";
  return (
    <div className="page-content">
      {/* File Modal */}
      <ShowImports
        open={showImports}
        batchId={selectedBatch?.bai_id}
        onClose={() => setShowImports(false)}
      />
      <Modal
        Modal
        id="createFileModal"
        isOpen={modal}
        toggle={toggle}
        modalClassName="zoomIn"
        centered
        tabIndex="-1"
      >
        <ModalHeader toggle={toggle} className="p-3 bg-primary-subtle">
          Upload File
        </ModalHeader>
        <ModalBody>
          <form
            className="needs-validation createfile-form"
            id="createfile-form"
            onSubmit={(e) => {
              e.preventDefault();
              fileValidation.handleSubmit();
              return false;
            }}
          >
            <div className="mb-4">
              <label htmlFor="file-input" className="form-label">
                <input
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  type="file"
                  className="form-control"
                  id="file-input"
                  validate={{
                    required: { value: true },
                  }}
                  inputProps={{
                    accept:
                      ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
                  }}
                  onChange={handleFileSelect}
                />
              </label>
            </div>
            <div className="mb-4">
              <label htmlFor="supplier" className="form-label">
                Supplier
              </label>
              <select
                className="form-select"
                id="supplier"
                name="supplier"
                onChange={fileValidation.handleChange}
                onBlur={fileValidation.handleBlur}
                value={fileValidation.values.supplier || ""}
              >
                <option value="">Select Supplier</option>
                {suppliers &&
                  suppliersList.map((supplier) => (
                    <option key={supplier.sup_id} value={supplier.sup_id}>
                      {supplier.sup_name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="mb-4">
              <label htmlFor="salesChannel" className="form-label">
                Sales Channel
              </label>
              <select
                className="form-select"
                id="salesChannel"
                name="salesChannel"
                onChange={fileValidation.handleChange}
                onBlur={fileValidation.handleBlur}
                value={fileValidation.values.salesChannel || ""}
              >
                <option value="">Select Sales Channel</option>
                <option value="FBA">FBA</option>
                <option value="FBM">FBM</option>
                <option value="eBay">eBay</option>
                <option value="Walmart">Walmart</option>
                <option value="Other">Other</option>
                <option value="Online Store">Online Store</option>
                <option value="LIQUIDATIONS">LIQUIDATIONS</option>
              </select>
            </div>

            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-danger waves-effect waves-light me-1"
                onClick={() => setModal(false)}
              >
                <i className="ri-close-line align-bottom"></i> Close
              </button>
              <button type="submit" className="btn btn-success" id="addNewFile">
                Upload
              </button>
            </div>
          </form>
        </ModalBody>
      </Modal>
      <DeleteModal
        show={showDelete}
        onDeleteClick={handleDelete}
        onCloseClick={() => setShowDelete(false)}
      />

      <Container fluid>
        <BreadCrumb title="" pageTitle="Import File" />
        <Row>
          <Col lg={12}>
            <Card id="orderList">
              <CardHeader className="border-0">
                <Row className="align-items-center gy-3">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">Import File</h5>
                  </div>
                  <div className="col-sm-auto">
                    <div className="d-flex gap-1 flex-wrap">
                      <button
                        type="button"
                        className="btn btn-success add-btn"
                        id="create-btn"
                        onClick={() => {
                          //         setIsEdit(false);
                          toggle();
                        }}
                      >
                        <i className="ri-add-line align-bottom me-1"></i> Import
                      </button>
                    </div>
                  </div>
                </Row>
              </CardHeader>

              <CardBody className="pt-0">
                <div>
                  {loading ? (
                    <Loader />
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={fileList || []}
                      isGlobalFilter={false}
                      isAddUserList={false}
                      customPageSize={50}
                      divClass="table-responsive table-card mb-1 mt-2"
                      tableClass="mb-0 align-middle table-border"
                      theadClass="table-light text-dark text-uppercase"
                      handleOrderClick={handleOrderClicks}
                      isOrderFilter={true}
                      SearchPlaceholder="Search for order ID, customer, order status or something..."
                    />
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ImportFile;
